import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './button.css';
import * as DOM from '../../dom.js';
import { StandardKeyboardEvent } from '../../keyboardEvent.js';
import { Color } from '../../../common/color.js';
import { mixin } from '../../../common/objects.js';
import { Emitter } from '../../../common/event.js';
import { Disposable } from '../../../common/lifecycle.js';
import { Gesture, EventType } from '../../touch.js';
import { renderCodiconsAsElement } from '../../codicons.js';
var defaultOptions = {
  buttonBackground: Color.fromHex('#0E639C'),
  buttonHoverBackground: Color.fromHex('#006BB3'),
  buttonForeground: Color.white
};
export var Button = /*#__PURE__*/function (_Disposable) {
  _inherits(Button, _Disposable);

  var _super = _createSuper(Button);

  function Button(container, options) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this);
    _this._onDidClick = _this._register(new Emitter());
    _this.options = options || Object.create(null);
    mixin(_this.options, defaultOptions, false);
    _this.buttonForeground = _this.options.buttonForeground;
    _this.buttonBackground = _this.options.buttonBackground;
    _this.buttonHoverBackground = _this.options.buttonHoverBackground;
    _this.buttonSecondaryForeground = _this.options.buttonSecondaryForeground;
    _this.buttonSecondaryBackground = _this.options.buttonSecondaryBackground;
    _this.buttonSecondaryHoverBackground = _this.options.buttonSecondaryHoverBackground;
    _this.buttonBorder = _this.options.buttonBorder;
    _this._element = document.createElement('a');
    DOM.addClass(_this._element, 'monaco-button');
    _this._element.tabIndex = 0;

    _this._element.setAttribute('role', 'button');

    container.appendChild(_this._element);

    _this._register(Gesture.addTarget(_this._element));

    [DOM.EventType.CLICK, EventType.Tap].forEach(function (eventType) {
      _this._register(DOM.addDisposableListener(_this._element, eventType, function (e) {
        if (!_this.enabled) {
          DOM.EventHelper.stop(e);
          return;
        }

        _this._onDidClick.fire(e);
      }));
    });

    _this._register(DOM.addDisposableListener(_this._element, DOM.EventType.KEY_DOWN, function (e) {
      var event = new StandardKeyboardEvent(e);
      var eventHandled = false;

      if (_this.enabled && (event.equals(3
      /* Enter */
      ) || event.equals(10
      /* Space */
      ))) {
        _this._onDidClick.fire(e);

        eventHandled = true;
      } else if (event.equals(9
      /* Escape */
      )) {
        _this._element.blur();

        eventHandled = true;
      }

      if (eventHandled) {
        DOM.EventHelper.stop(event, true);
      }
    }));

    _this._register(DOM.addDisposableListener(_this._element, DOM.EventType.MOUSE_OVER, function (e) {
      if (!DOM.hasClass(_this._element, 'disabled')) {
        _this.setHoverBackground();
      }
    }));

    _this._register(DOM.addDisposableListener(_this._element, DOM.EventType.MOUSE_OUT, function (e) {
      _this.applyStyles(); // restore standard styles

    })); // Also set hover background when button is focused for feedback


    _this.focusTracker = _this._register(DOM.trackFocus(_this._element));

    _this._register(_this.focusTracker.onDidFocus(function () {
      return _this.setHoverBackground();
    }));

    _this._register(_this.focusTracker.onDidBlur(function () {
      return _this.applyStyles();
    })); // restore standard styles


    _this.applyStyles();

    return _this;
  }

  _createClass(Button, [{
    key: "onDidClick",
    get: function get() {
      return this._onDidClick.event;
    }
  }, {
    key: "setHoverBackground",
    value: function setHoverBackground() {
      var hoverBackground;

      if (this.options.secondary) {
        hoverBackground = this.buttonSecondaryHoverBackground ? this.buttonSecondaryHoverBackground.toString() : null;
      } else {
        hoverBackground = this.buttonHoverBackground ? this.buttonHoverBackground.toString() : null;
      }

      if (hoverBackground) {
        this._element.style.backgroundColor = hoverBackground;
      }
    }
  }, {
    key: "style",
    value: function style(styles) {
      this.buttonForeground = styles.buttonForeground;
      this.buttonBackground = styles.buttonBackground;
      this.buttonHoverBackground = styles.buttonHoverBackground;
      this.buttonSecondaryForeground = styles.buttonSecondaryForeground;
      this.buttonSecondaryBackground = styles.buttonSecondaryBackground;
      this.buttonSecondaryHoverBackground = styles.buttonSecondaryHoverBackground;
      this.buttonBorder = styles.buttonBorder;
      this.applyStyles();
    }
  }, {
    key: "applyStyles",
    value: function applyStyles() {
      if (this._element) {
        var background, foreground;

        if (this.options.secondary) {
          foreground = this.buttonSecondaryForeground ? this.buttonSecondaryForeground.toString() : '';
          background = this.buttonSecondaryBackground ? this.buttonSecondaryBackground.toString() : '';
        } else {
          foreground = this.buttonForeground ? this.buttonForeground.toString() : '';
          background = this.buttonBackground ? this.buttonBackground.toString() : '';
        }

        var border = this.buttonBorder ? this.buttonBorder.toString() : '';
        this._element.style.color = foreground;
        this._element.style.backgroundColor = background;
        this._element.style.borderWidth = border ? '1px' : '';
        this._element.style.borderStyle = border ? 'solid' : '';
        this._element.style.borderColor = border;
      }
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "label",
    set: function set(value) {
      if (!DOM.hasClass(this._element, 'monaco-text-button')) {
        DOM.addClass(this._element, 'monaco-text-button');
      }

      if (this.options.supportCodicons) {
        DOM.reset.apply(DOM, [this._element].concat(_toConsumableArray(renderCodiconsAsElement(value))));
      } else {
        this._element.textContent = value;
      }

      if (typeof this.options.title === 'string') {
        this._element.title = this.options.title;
      } else if (this.options.title) {
        this._element.title = value;
      }
    }
  }, {
    key: "enabled",
    get: function get() {
      return !DOM.hasClass(this._element, 'disabled');
    },
    set: function set(value) {
      if (value) {
        DOM.removeClass(this._element, 'disabled');

        this._element.setAttribute('aria-disabled', String(false));

        this._element.tabIndex = 0;
      } else {
        DOM.addClass(this._element, 'disabled');

        this._element.setAttribute('aria-disabled', String(true));

        DOM.removeTabIndexAndUpdateFocus(this._element);
      }
    }
  }]);

  return Button;
}(Disposable);